// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.activityContainer_Z9oFy {
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  border-top: 1px solid #11a38132;
  padding-top: 20px;
  gap: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/InfoActivity/InfoActivity.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,+BAA+B;EAC/B,iBAAiB;EACjB,SAAS;AACX","sourcesContent":[".activityContainer {\n  display: flex;\n  flex-direction: column;\n  margin-top: 20px;\n  border-top: 1px solid #11a38132;\n  padding-top: 20px;\n  gap: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"activityContainer": `activityContainer_Z9oFy`
};
export default ___CSS_LOADER_EXPORT___;
